// extracted by mini-css-extract-plugin
export default {"wrapper":"T5-z"};